export const addMessageListener  = (listener) => {
  if (isMobileAndroidApp()) {
    document.addEventListener('message', listener);
  }
  if (isMobileIosApp()) {
    window.addEventListener('message', listener);
  }
};

export const removeMessageListener  = (listener) => {
  if (isMobileAndroidApp()) {
    document.removeEventListener('message', listener);
  }
  if (isMobileIosApp()) {
    window.removeEventListener('message', listener);
  }
};

export function isMobileApp () {
  const userAgent = navigator.userAgent.toLowerCase();
  return (userAgent && (userAgent.includes("adicapp-ios") || userAgent.includes("adicapp-android")));
}

export function isMobileIosApp () {
  const userAgent = navigator.userAgent.toLowerCase();
  return (userAgent && (userAgent.includes("adicapp-ios")));
}

export function isMobileAndroidApp () {
  const userAgent = navigator.userAgent.toLowerCase();
  return (userAgent && (userAgent.includes("adicapp-android")));
}


export function isIPad () {
  const userAgent = navigator.userAgent.toLowerCase();
  return (userAgent && (userAgent.includes("ipad")));
}

export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function isIosMobile() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}
